export const VehicleTypes = {
        'new': 0,
        used: 1,
        cpo: 2
}
